import { useMemo } from "react";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { useSignalsManagementViewModel } from "app/pages/sales-intelligence/sub-modules/signals/hooks/useSignalsManagementViewModel";
import type SignalTypeWithIcon from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalTypeWithIcon";
import signalsService from "app/pages/sales-intelligence/sub-modules/signals/services/signalsService";

export type AccountSignalTypeEntry = SignalTypeWithIcon & {
    isComingSoon: boolean;
};

export const useAccountSignalsPageTypes = () => {
    const viewModel = useSignalsManagementViewModel();
    const isHighLevelAccount = salesSettingsHelper.isHighLevelAccount();

    const signalTypes = useMemo(
        (): readonly AccountSignalTypeEntry[] =>
            signalsService.orderedSignalTypes.map((type) => ({
                type,
                icon: signalsService.getIconForSignalType(type),
                isComingSoon: signalsService.getSignalTypeLifecycleState(type) === "coming-soon",
            })),
        [],
    );

    const scrollableTypes = useMemo(() => signalTypes.filter(({ isComingSoon }) => !isComingSoon), [signalTypes]);

    return {
        displayTypes: signalTypes,
        scrollableTypes,
        isHighLevelAccount,
        viewModel,
    };
};
